import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectApplicantsState = (state: BaseState) => state.applicants;

export const selectApplicantsIsLoading = createSelector(
  selectApplicantsState,
  (state) => state.isLoading
);